import { DataServer } from "../../../../config.axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";

interface SampleExcelState {
  SampleExcel: {
    load: boolean;
    data: [];
  };
}

export const SampleExcelSlice = createSlice({
  name: "SampleExcel",
  initialState: {
    SampleExcel: {
      load: false,
      data: [],
    },
  } as SampleExcelState,
  reducers: {
    resetSampleExcelState: (state: any) => {
        state.SampleExcel.data = [];
    },
},
  extraReducers: (builder: any) => {
    builder
      .addCase(fetchSampleExcel.pending, (state: SampleExcelState) => {
        state.SampleExcel.load = true;
      })
      .addCase(fetchSampleExcel.fulfilled, (state: SampleExcelState, action: any) => {
        state.SampleExcel.data = action.payload;
        state.SampleExcel.load = false;
      })
      .addCase(fetchSampleExcel.rejected, (state: SampleExcelState) => {
        state.SampleExcel.load = false;
      })
  },
});

export const { resetSampleExcelState } = SampleExcelSlice.actions;
export default SampleExcelSlice.reducer;

export const fetchSampleExcel = createAsyncThunk(
  "SampleExcel/fetchSampleExcel",
  async (param: { apiParam : {tpi_firm_id: any} }, thunkAPI) => {
    try {      
      const { data } = await DataServer.post("api/downloadElementLibrarySampleExcel", {
        tpi_firm_id: param.apiParam.tpi_firm_id
      });

      return data.data;

    } catch (error) {
      return(error);
    }
  }
);

export const uploadPropertyExcelFile = createAsyncThunk(
  "ElementPropertyByElement/uploadPropertyExcelFile",
  async (param: { apiParam: { tpi_firm_id: any; file: any } }, thunkAPI) => {
    try {
      const { data } = await DataServer.post("api/uploadPropertyExcelFile", {
        tpi_firm_id: param.apiParam.tpi_firm_id,
        file: param.apiParam.file
      });

      toast.success(data.message,{theme: "colored"});

      return data.data;
    } catch (error) {
      return error;
    }
  }
);
